import { ClientOnly } from "remix-utils/client-only";
import { ClientMapDemo } from "./components/map-demo.client";
import { Outlet, type LoaderFunctionArgs } from "react-router";
import { Dialog } from "@www/ui/dialog";

export const loader = async (args: LoaderFunctionArgs) => {
  return null;
};

export default function MapRoute() {
  return (
    <>
      <ClientOnly>{() => <ClientMapDemo />}</ClientOnly>
      <Dialog open={true}>
        <Outlet />
      </Dialog>
    </>
  );
}
